import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const BoardTabs = ({ categoryTabs, activeTab, tabRefs, tabScrollRef, onSelectTab, onPrevTab, onNextTab }) => {
  return (
    <div className="mx-auto mb-3 flex w-full items-center gap-2 md:mb-4 md:max-w-[1120px]">
      <button
        type="button"
        onClick={onPrevTab}
        className="cursor-pointer flex h-8 w-8 shrink-0 items-center justify-center border-none bg-transparent text-[28px] text-[#007524] outline-none ring-0 appearance-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 md:h-10 md:w-10 md:text-[32px]"
        aria-label="Tab trước"
      >
        <ChevronLeft size={34} strokeWidth={2.5} />
      </button>

      <div
        ref={tabScrollRef}
        className="scrollbar-hide flex min-w-0 flex-1 items-center justify-start gap-[4px] overflow-x-auto overflow-y-visible px-[2px] pt-[2px] pb-1 md:gap-1"
      >
        {categoryTabs.map((tab) => {
          const isActive = activeTab === tab;

          if (isActive) {
            return (
              <div
                key={tab}
                ref={(el) => {
                  tabRefs.current[tab] = el;
                }}
                className="rounded-[8px] bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px] md:rounded-[10px] md:p-[1px]"
              >
                <button
                  type="button"
                  onClick={() => onSelectTab(tab)}
                  className="h-[26px] whitespace-nowrap rounded-[7px] border-none appearance-none bg-gradient-to-b from-[#00CD32] to-[#048724] px-2 text-[13px] 
                  font-bold uppercase text-white outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 md:h-[36px] md:rounded-[8px] md:px-4 md:text-[18px]"
                >
                  {tab}
                </button>
              </div>
            );
          }

          return (
            <button
              key={tab}
              ref={(el) => {
                tabRefs.current[tab] = el;
              }}
              type="button"
              onClick={() => onSelectTab(tab)}
              className="h-[26px] whitespace-nowrap rounded-[6px] border border-[#9a9a9a] appearance-none bg-[#AEAEAE] px-2 text-[13px] font-bold uppercase text-white outline-none ring-0 shadow-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 md:h-[36px] md:rounded-[8px] md:px-4 md:text-[18px]"
            >
              {tab}
            </button>
          );
        })}
      </div>

      <button
        type="button"
        onClick={onNextTab}
        className="cursor-pointer flex h-8 w-8 shrink-0 items-center justify-center border-none bg-transparent text-[28px] leading-none text-[#007524] outline-none ring-0 appearance-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 md:h-10 md:w-10 md:text-[32px]"
        aria-label="Tab tiếp theo"
      >
        <ChevronRight size={34} strokeWidth={2.5} />
      </button>
    </div>
  );
};

export default BoardTabs;
